import { Dialog } from '@material-ui/core';
import Form, { InputType } from '../../lib/Formik';
import { PasswordGuidelines } from '../../lib/PasswordGuidelines';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import * as yup from 'yup';
import { SetPasswordPayload, verifyQuestionnaire } from '../../redux-store/types/login';
import { forgotQuestionAnswerOtp, validateSecretAnswer } from '../../redux-store/actions/login';
import { connect } from 'react-redux';
import { onSetPassword } from '../../redux-store/actions/login';
import { useEffect, useState, useMemo } from 'react';
import { NoteModals } from '../../lib/NoteModals';

const {
    setPassword,
    common,
    login: { form },
    resetSecurityQuestion,
    dashboard,
    resetPassword,
} = en;

interface FormFieldProps {
    answer: string;
    question: string;
}

const ResetQuestion = ({ value, ...props }: any) => {
    const handleClick = async () => {
        const requestData = {
            mobile: '',
            pekrn: '',
            pan: '',
            email: '',
            userId: props.history.location.state.pan,
        };
        try {
            let res = await props.forgotQuestionAnswerOtp({
                ...requestData,
            });
            props.history.push('/investor/reset-question-otp', {
                ...props.location.state,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };
    return (
        <div className="remember-forgot">
            <a className="forgot-password-btn" onClick={handleClick}>
                {resetSecurityQuestion.question}
            </a>
        </div>
    );
};

const formFields: Partial<InputType>[] = [
    {
        label: setPassword.selectQuestion,
        name: 'question',
        type: 'text',
        multiline: true,
        disabled: true,
    },
    {
        label: setPassword.answer,
        name: 'answer',
        type: 'password',
    },
];

const initialValues: FormFieldProps = {
    answer: '',
    question: '',
};

const validationSchema = yup.object({
    answer: yup.string().required(form.answer),
});

function SignInQuestionnaire(props: any) {
    const {
        reqId,
        pan,
        pekrn,
        data,
        action: otp_action,
        fromForgotPassword = false,
    } = props.location.state || {};

    const onSubmit = async (values: FormFieldProps, action: FormikHelpers<FormFieldProps>) => {
        const [question] = data;
        const payload: verifyQuestionnaire = {
            reqId,
            pan,
            pekrn,
            action: otp_action,
            data: [{ questionTypeId: question.questionTypeId, secretAnswer: values.answer }],
        };
        try {
            let res = await props.validateSecretAnswer(payload);
            if (!Object.keys((res || {}).body).includes('userSubjectReference')) {
                props.history.push('/investor/reset-password', { pan, pekrn, ...(res || {}).body });
            }
        } catch (err: any) {
            alert(err.message);
        }
        action.setSubmitting(false);
    };

    const updateFormFields = useMemo((): Partial<InputType>[] => {
        return [
            ...formFields,
            {
                name: 'resetQuestion',
                component: ResetQuestion,
                extraProps: {
                    history: props.history,
                    forgotQuestionAnswerOtp: props.forgotQuestionAnswerOtp,
                    ...props,
                },
            },
        ];
    }, [props.history]);

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
    });

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('signin');
        }
        const [question] = data || [];
        formik.setFieldValue('question', (question || {}).secretQuestion);
    }, []);

    return (
        <>
            <div className="signup-padding signin-questionnaire">
                <h4 className="text-center">
                    {fromForgotPassword ? resetPassword.heading : setPassword.twoFAHeading}
                </h4>
                <Form
                    ui={updateFormFields}
                    submitButtonLabel={setPassword.action.continue}
                    formik={formik}
                />
            </div>
        </>
    );
}

export default connect(null, { validateSecretAnswer, forgotQuestionAnswerOtp })(
    SignInQuestionnaire,
);
